import React from 'react';

type props = {
  isModel?: boolean;
  InnerComponent: React.ReactNode;
};

const Modal: React.FunctionComponent<props> = ({ isModel, InnerComponent }): JSX.Element => {
  return (
    <div className="">
      {isModel && (
        <div
          className="fixed inset-0 z-50 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex min-h-screen items-center justify-center p-4">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            <div className="relative z-10 my-8 flex w-full max-w-full justify-center">{InnerComponent}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Modal;
